import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { RegexEnum } from '../../../../shared/model/enums/RegexPattern';

export const shippingAddressError =
  (control1: string, control2: string, control3: string): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => {
    const isChargesEnabled = control.get(control1)?.value;
    const charges = control.get(control2)?.value;
    const shippingAddress = control.get(control3)?.value;

    const chargesExist = isChargesEnabled && charges && charges.length > 0;
    const noShippingAddress = !(shippingAddress && shippingAddress.length > 0);

    if (chargesExist && noShippingAddress) {
      return { shippingAddressError: true };
    }
    return null;
  };

export function handlePostalCodeValidationBasedOnCountry(
  control: AbstractControl | null,
  selectedCountry: { name: string },
): void {
  if (!control) return;

  if (selectedCountry?.name === 'المملكة العربية السعودية') {
    control.setValidators([
      Validators.required,
      Validators.minLength(5),
      Validators.maxLength(5),
      Validators.pattern(RegexEnum.numberOnly),
    ]);
    control.enable();
  } else {
    control.setValue('');
    control.disable();
  }

  control.updateValueAndValidity();
}
